import { toInterceptor } from 'nike-re-framejs';
import { extractMiddlewareCtx } from './utils';
import { logEvent } from '../common/logs';
import { DEBUG_CONSOLE_MODE } from '../common/logs';

export const consoleMiddleware = () =>
    toInterceptor({
        id: 'CONSOLE_LOG_MIDDLEWARE',
        before: ctx => {
            const { eventName, eventArgs } = extractMiddlewareCtx(ctx);
            logReframeEventToConsole(eventName, eventArgs);
            return ctx;
        }
    });

export const logReframeEventToConsole = DEBUG_CONSOLE_MODE
    ? (event, args = []) => event && logEvent('REFRAME', event, args, 'green')
    : () => {};
